<template>
  <div id="app">
      <y-header :showSearch="showSearch" :specialHead="specialHead" :showLine="isShowLine"></y-header>
      <router-view v-on:publicHeader="publicHeader" v-on:publicFooter="publicFooter" v-on:publicRightBar="publicRightBar" :key="this.$route.path"/>
      <y-footer v-if="footerShow"></y-footer>
      <l-footer v-if="!footerShow"></l-footer>
      <right-bar v-if="rightBarShow"></right-bar>

  </div>
</template>
<script>
    import YHeader from './components/header'
    import YFooter from './components/footer'
    import LFooter from './components/loginFooter'
    import rightBar from './components/rightBar'
export default {
  name: 'App',
    data () {
        return {
            specialHead:1,
            showSearch:true,
            footerShow:true,
            rightBarShow:true,
            isShowLine:false,
        }
    },
    mounted() {
        window.addEventListener("scroll", this.scrollShowIcon, true);
    },
    methods:{
        publicHeader(type,index){
            this.specialHead = index;
            if(type == 2){
                this.showSearch = false;
            }else {
                this.showSearch = true;
            }
        },
        publicFooter(type){
            if(type == 2){
                this.footerShow = false;
            }else {
                this.footerShow = true;
            }
        },
        publicRightBar(type){
            if(type == 2){
                this.rightBarShow = false;
            }else {
                this.rightBarShow = true;
            }

        },
        // scrollShowIcon(){
        //     if (
        //         !!document.documentElement.scrollTop &&
        //         document.documentElement.scrollTop > 45
        //     ) {
        //         if(this.showSearch){
        //             this.isShowLine = true;
        //         }
        //     } else {
        //         if(this.showSearch){
        //             this.isShowLine = false;
        //         }
        //     }
        // }
    },
    components: {
        YHeader,
        YFooter,
        LFooter,
        rightBar
    }
}
</script>

<style  lang="less">
    @import './assets/style/common';
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  /*margin-top: 60px;*/
}
    /*.page-center{*/
    /*    padding-top: 140px;*/
    /*}*/
    /*@media screen and (max-width: 1600px) {*/
    /*    .page-center {*/
    /*        padding-top: 175px;*/
    /*    }*/
    /*}*/

</style>



// WEBPACK FOOTER //
// src/App.vue